import {getButtonOutlineWhite} from '@hconnect/common/styles'
import {useUpmPlantContext} from '@hconnect/upm'
import {usePermission} from '@hproduce/permissions'
import EditIcon from '@mui/icons-material/Edit'
import {Button} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type EditKpisButtonProps = {
  onClick: () => void
  year: number
}

/**
 * Edit KPIs button - only visible to users with EDIT_SLA_TRACKING_KPIS_SETUP permission
 * and only for the current year
 */
export const EditKpisButton = ({onClick, year}: EditKpisButtonProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {plantId, country: countryId} = useUpmPlantContext()

  const currentYear = new Date().getFullYear()

  const canEditKpiDefinitions = usePermission({
    permissionTypes: ['EDIT_SLA_TRACKING_KPIS_SETUP'],
    plantContext: {plantId, countryId}
  })

  // Hide button if not current year or no permission - editing is only allowed for current year to avoid complications with historical data and future years which may not be set up yet
  if (year !== currentYear || !canEditKpiDefinitions) {
    return null
  }

  return (
    <Button
      variant="outlined"
      startIcon={<EditIcon />}
      onClick={onClick}
      data-cy="edit-kpis-button"
      sx={(theme) => getButtonOutlineWhite(theme)}
    >
      {t('editKpisModal.action.edit')}
    </Button>
  )
}
